import {ReactNode, useEffect, useState} from "react";

export default function (props: {
    children: ReactNode | (() => ReactNode)
}) {
    const [init, setInit] = useState(false)

    useEffect(() => {
        setInit(true)
    }, []);

    return <>
        {init && (
            typeof props.children === 'function' ? props.children() : props.children
        )}
    </>
}